"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _excluded = ["borderRadius", "gridGap", "gridColumnGap", "gridRowGap", "gridgap"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
/* eslint-disable react/prop-types */
var Box = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var borderRadius = _ref.borderRadius,
    gridGap = _ref.gridGap,
    gridColumnGap = _ref.gridColumnGap,
    gridRowGap = _ref.gridRowGap,
    gridgap = _ref.gridgap,
    props = _objectWithoutProperties(_ref, _excluded);
  var fallbackGapValue = typeof gridgap === 'number' ? "".concat(gridgap * 8, "px") : undefined;
  return /*#__PURE__*/(
    // Adapter for muiv5
    // https://mui.com/material-ui/migration/v5-component-changes/#box
    _react["default"].createElement(_Box["default"], _extends({
      ref: ref,
      borderRadius: typeof borderRadius === 'number' ? "".concat(borderRadius, "px") : borderRadius,
      gap: gridGap || fallbackGapValue,
      columnGap: gridColumnGap,
      rowGap: gridRowGap
    }, props))
  );
});
Box.propTypes = process.env.NODE_ENV !== "production" ? {
  gridgap: _propTypes["default"].number
} : {};
Box.defaultProps = {
  gridgap: 0
};
var _default = exports["default"] = Box;